import * as $ from "jquery";
import * as Backbone from "backbone";
import * as _ from "underscore";
import * as Marionette from "backbone.marionette";
import { on, Options } from "../utils/decorators";

@Options({
    template: false,
    ui: {
    }
})
export default class PlayInlineView extends Marionette.View<Backbone.Model>{
    file_url;
    audioElement;
    is_playing=false;
    is_loaded=false;
    listenerRef;
    onRender(){
        this.$el.on("click", _.bind(this.onClick, this));
        this.file_url = this.$el.data("js-play-inline");

    }
    onClick(event) {
        if(!this.is_playing){
            this.playAudio();
            this.$el.addClass('is-playing')
        }else{
            this.stopAudio();
            this.$el.removeClass('is-playing')
        }

    }
    playAudio(){
        if(this.is_loaded){
            this.audioElement.play();
            this.is_playing=true;
        }else{
            this.audioElement = document.createElement('audio');
            this.audioElement.setAttribute('src', this.file_url);
            this.audioElement.load();
            this.listenerRef = this.canPlay.bind(this);
            this.audioElement.addEventListener("canplay", this.listenerRef);
        }
    }
    canPlay(){
        this.audioElement.removeEventListener("canplay", this.listenerRef);
        this.audioElement.play();
        this.is_playing=true;
        this.is_loaded=true;

    }
    stopAudio(){
        this.audioElement.currentTime = 0;
        this.audioElement.pause();
        this.is_playing=false;
    }
    onBeforeDetach() {
        this.$el.off("click");
    }
}



// WEBPACK FOOTER //
// ./@modules/views/play-inline-view.ts